// Single source of truth for Stripe Payment Links.
export const STRIPE_VIP_URL = "https://buy.stripe.com/eVqbJ01AEgNQ04YdPI2go0d";
export const STRIPE_STANDARD_URL = "https://buy.stripe.com/dRm14m1AE8hk6tm2702go0w";

// Standard tickets are sold out — all funnels point to VIP.
export const STANDARD_SOLD_OUT = true;

// The whole event is sold out — site switches to waitlist mode.
export const EVENT_SOLD_OUT = true;
